import {
	OrderFieldTypeEnum,
	type OrderSetupDetailResponseDto,
} from "Infrastructure/Api/Api";
import { Resources } from "Infrastructure/Translation/Resources";
import type { OrderFieldValue } from "Settings/Modules/OrderSetup/Components/OrderFieldOptionsModal";
import type { TOptions } from "i18next";
import type { ObjPathProxy } from "ts-object-path";
import { z } from "zod";

const orderValidationMessagesResource = Resources.base.order.validationMessages;

export const validateOrderFields = (
	data,
	ctx: z.RefinementCtx,
	t: (
		resourcePath: ObjPathProxy<unknown, string>,
		options?: TOptions,
	) => string,
	orderSetup: OrderSetupDetailResponseDto | null | undefined,
) => {
	data.fields?.forEach((field, index: number) => {
		const orderField = orderSetup?.orderFields.find(
			(f) => f.id === field.orderFieldId,
		);
		if (!orderField) return;

		const { value } = field;
		let parsedValue: string | number | boolean | null | undefined = value;

		if (value === null || value === undefined)
			return parsedValue !== null ? String(parsedValue) : null;

		let isValid = false;
		let message = `${t(orderValidationMessagesResource.general)} ${orderField.label}`;

		switch (orderField.type) {
			case OrderFieldTypeEnum.boolean:
				if (
					value === "true" ||
					value === "false" ||
					typeof value === "boolean" ||
					!value
				) {
					parsedValue = value === "true" || value === true;
					isValid = true;
				}
				message = `${t(orderValidationMessagesResource.boolean)} ${orderField.label}`;
				break;
			case OrderFieldTypeEnum.integer:
				if (/^-?\d+$/.test(String(value)) || !value) {
					parsedValue = Number(value);
					isValid = true;
				}
				message = `${t(orderValidationMessagesResource.integer)} ${orderField.label}`;
				break;
			case OrderFieldTypeEnum.float:
				if (/^-?\d*\.?\d+$/.test(String(value)) || !value) {
					parsedValue = Number(value);
					isValid = true;
				}
				message = `${t(orderValidationMessagesResource.integer)} ${orderField.label}`;
				break;
			case OrderFieldTypeEnum.string:
				isValid = typeof value === "string" || !value;
				message = `${t(orderValidationMessagesResource.string)} ${orderField.label}`;
				break;
			case OrderFieldTypeEnum.enum: {
				const optionValues = Object.values(
					JSON.parse(orderField.value) as OrderFieldValue[],
				).map((option) => option.value);

				if (optionValues?.includes(String(value)) || !value) {
					isValid = true;
				}

				message = `${t(orderValidationMessagesResource.enum)} ${orderField.label}`;
				break;
			}
		}

		if (!isValid) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message,
				path: ["fields", index, "value"],
			});
		}

		field.value = parsedValue !== null ? String(parsedValue) : null;
	});
};
